import { useDispatch } from 'react-redux';
import { addToast } from '../../store/ducks/toast/actions';
import { EToastTypes } from '../../store/ducks/toast/types';
import { NewCartItem } from './models';

interface BulkErrorResult {
  hasErrors: boolean;
  allFailed: boolean;
}

export const useBulkErrorToast = () => {
  const dispatch = useDispatch();

  const dispatchBulkErrorToast = (
    items: NewCartItem[],
    globalErrors: string[]
  ): BulkErrorResult => {
    const hasGlobalErrors = globalErrors.length > 0;
    const allFailed =
      hasGlobalErrors ||
      (items.length > 0 &&
        items.every((item) => item.extension_attributes?.fail_message));
    const someFailed =
      !allFailed &&
      items.some((item) => item.extension_attributes?.fail_message);

    if (allFailed) {
      dispatch(
        addToast({
          type: EToastTypes.DANGER,
          message: 'Não foi possível processar os itens do pedido.',
          durationInMS: 5000,
          labelActionOne: 'Fechar'
        })
      );
      return { hasErrors: true, allFailed: true };
    }

    if (someFailed) {
      dispatch(
        addToast({
          type: EToastTypes.DANGER,
          message:
            'Alguns itens não puderam ser processados. Verifique os itens destacados e tente novamente.',
          durationInMS: 5000,
          labelActionOne: 'Fechar'
        })
      );
      return { hasErrors: true, allFailed: false };
    }

    return { hasErrors: false, allFailed: false };
  };

  return { dispatchBulkErrorToast };
};
